import React from 'react';

import s from './styles.module.scss';

interface IProps {
  name: string;
  value: string | number;
}

const Legend: React.FC<IProps> = (props) => {
  const { name, value } = props;
  return (
    <div className={s.wrapper}>
      {name}: {value}
    </div>
  );
};

export default Legend;
